import { render, staticRenderFns } from "./page-ie-fallback.vue?vue&type=template&id=c83a7808&"
import script from "./page-ie-fallback.vue?vue&type=script&lang=js&"
export * from "./page-ie-fallback.vue?vue&type=script&lang=js&"
import style0 from "./page-ie-fallback.vue?vue&type=style&index=0&id=c83a7808&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports